/**
 * Koko sprite animation sets — ported verbatim from the native app's
 * `KokoAnimationSet.swift`. Per-frame hold durations follow the Pokemon
 * Gen-5 "animation on twos" style: key poses hold longer, transitions
 * flash past quickly. Keep these numbers in sync with the Swift source.
 */

export type KokoAnimationStateName =
  | "flight"
  | "perched"
  | "listening"
  | "thinking"
  | "talking"
  | "pointing"
  | "swoop";

export interface KokoAnimationSet {
  frameNames: readonly string[];
  /** Seconds each frame is held before advancing. Same length as frameNames. */
  frameHoldDurations: readonly number[];
  loops: boolean;
}

function framesFor(prefix: string): readonly string[] {
  return [`${prefix}_1`, `${prefix}_2`, `${prefix}_3`, `${prefix}_4`] as const;
}

export const KOKO_ANIMATIONS: Record<KokoAnimationStateName, KokoAnimationSet> = {
  flight: {
    frameNames: framesFor("koyal_flight"),
    frameHoldDurations: [0.28, 0.14, 0.28, 0.14],
    loops: true,
  },
  perched: {
    frameNames: framesFor("koyal_perched"),
    frameHoldDurations: [0.35, 0.18, 0.35, 0.18],
    loops: true,
  },
  listening: {
    frameNames: framesFor("koyal_listening"),
    frameHoldDurations: [0.2, 0.2, 0.4, 0.2],
    loops: true,
  },
  thinking: {
    frameNames: framesFor("koyal_thinking"),
    frameHoldDurations: [0.18, 0.18, 0.4, 0.18],
    loops: true,
  },
  talking: {
    frameNames: framesFor("koyal_talking"),
    frameHoldDurations: [0.25, 0.18, 0.18, 0.25],
    loops: true,
  },
  pointing: {
    frameNames: framesFor("koyal_pointing"),
    frameHoldDurations: [0.16, 0.16, 0.4, 0.4],
    loops: true,
  },
  swoop: {
    frameNames: framesFor("koyal_swoop"),
    frameHoldDurations: [0.14, 0.3, 0.14, 0.3],
    loops: true,
  },
};

/** Full list of sprite asset names — used to preload images. */
export const ALL_SPRITE_NAMES: readonly string[] = (
  Object.values(KOKO_ANIMATIONS).flatMap((animation) => animation.frameNames)
);
